import React, { useCallback, useMemo } from 'react';
import { Autocomplete, Box, Button, Grid, TextField, Typography } from '@mui/material';
import { simulateEvent } from 'utils/functions';
import FormSection from './FormSection';

const FormBelow = function (props) {
  const { controls, onChange, errors, hasErrors, handleNext } = props;

  const paymentConditions = [
    { id: 1, description: 'Al contado' },
    { id: 2, description: '15 días' },
    { id: 3, description: '30 días' },
    { id: 4, description: '45 días' },
    { id: 5, description: '60 días' },
    { id: 6, description: '75 días' },
    { id: 7, description: '90 días' },
    { id: 8, description: '120 días' },
  ];

  const deliveryOptions = [
    { id: 1, description: 'Despacho en Planta' },
    { id: 2, description: 'Retira en Veterquimica' },
  ];

  const paymentConditionValue = useMemo(
    () => paymentConditions.find((p) => p.id === controls.paymentCondition) ?? null,
    [paymentConditions, controls.paymentCondition],
  );

  const deliveryValue = useMemo(
    () => deliveryOptions.find((d) => d.id === controls.delivery) ?? null,
    [deliveryOptions, controls.delivery],
  );

  const handleChange = useCallback(
    (e, newValue) => onChange(simulateEvent('paymentCondition', 'string', newValue?.id ?? '')),
    [onChange, simulateEvent],
  );

  const handleDeliveryChange = useCallback(
    (e, newValue) => onChange(simulateEvent('delivery', 'string', newValue?.id ?? '')),
    [onChange, simulateEvent],
  );

  // Condiciones comerciales y observaciones, al final del formulario.
  return (
    <>
      <FormSection title="Condiciones">
        <Grid container columnSpacing={2} rowSpacing={0.5}>
          <Grid item xs={12} md={6}>
            <Autocomplete
              disablePortal
              id="delivery"
              value={deliveryValue}
              options={deliveryOptions}
              getOptionLabel={(opt) => opt.description}
              fullWidth
              onChange={handleDeliveryChange}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  required
                  label="Entrega"
                  error={errors.delivery?.length > 0}
                  helperText={errors.delivery ? errors?.delivery[0] : ' '}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Autocomplete
              disablePortal
              id="paymentCondition"
              value={paymentConditionValue}
              options={paymentConditions}
              getOptionLabel={(opt) => opt.description}
              fullWidth
              onChange={handleChange}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  required
                  label="Condición de pago"
                  error={errors.paymentCondition?.length > 0}
                  helperText={errors.paymentCondition ? errors?.paymentCondition[0] : ' '}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="comments"
              label="Observaciones"
              variant="outlined"
              value={controls.comments}
              onChange={onChange}
              error={errors.comments?.length > 0}
              helperText={errors.comments ? errors?.comments[0] : null}
              fullWidth
              minRows={4}
              multiline
            />
          </Grid>
        </Grid>
      </FormSection>
      {/* El aviso queda junto al botón para quien vuelva a bajar sin haber corregido los campos;
          desaparece solo cuando ya no quedan errores. */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 2,
          mb: 6,
        }}>
        {hasErrors && (
          <Typography id="quote-form-errors" variant="body2" color="error" role="alert">
            Hay campos con errores. Revise los campos marcados.
          </Typography>
        )}
        <Button
          variant="contained"
          size="large"
          onClick={handleNext}
          aria-describedby={hasErrors ? 'quote-form-errors' : undefined}>
          Previsualizar
        </Button>
      </Box>
    </>
  );
};

export default FormBelow;
